import styled from 'styled-components';

export const Container = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  background: ${props => props.theme.background};
`;
